import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { FiAward } from 'react-icons/fi';

const LiveWinnersMarquee = ({ entries }) => {
  // Filter only winners (exclude "Better Luck Next Time" or "Try Again")
  const recentWinners = entries
    .filter(e => !e.reward.includes('Luck') && !e.reward.includes('Try'))
    .slice(0, 10); // Take top 10 most recent

  if (recentWinners.length === 0) return null;

  return (
    <div className="absolute bottom-0 left-0 w-full overflow-hidden bg-slate-900/80 border-t border-slate-800 backdrop-blur-md py-3 flex items-center z-20">
      <div className="px-4 border-r border-slate-700 bg-slate-900/90 z-30 flex items-center gap-2 text-amber-400 font-bold uppercase text-xs tracking-wider whitespace-nowrap shadow-[10px_0_15px_-3px_rgba(0,0,0,0.5)]">
        <SafeIcon icon={FiAward} className="text-lg animate-pulse" />
        Live Winners
      </div>
      
      <div className="flex-1 overflow-hidden relative flex">
        <motion.div 
          className="flex whitespace-nowrap gap-8 px-8"
          animate={{ x: [0, -1000] }}
          transition={{ repeat: Infinity, duration: 25, ease: "linear" }}
        >
          {/* Duplicate array for seamless looping */}
          {[...recentWinners, ...recentWinners, ...recentWinners].map((winner, idx) => (
            <div key={idx} className="flex items-center gap-2 text-sm">
              <span className="text-white font-medium">{winner.name}</span>
              <span className="text-slate-500 text-xs">won</span>
              <span className="text-emerald-400 font-bold bg-emerald-500/10 px-2 py-0.5 rounded border border-emerald-500/20">
                {winner.reward}
              </span>
            </div>
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default LiveWinnersMarquee;